import * as React from 'react';
import { IKeywordElement, Alphabet } from '../models/keyword-elements';
import { Textbox } from '../../global/components/inputs/textbox/textbox';

interface IProps {
    items: IKeywordElement[];
    title: string;
    searchButtonText: string;
}

// Internal state of the component
interface IState {
    loading: boolean;
    currentLetter: string;
    searchText: string;
    inputText: string;
}

export class KeywordApp extends React.Component<IProps, IState> {
    state: IState = {
        loading: true,
        currentLetter: '',

        inputText: '',
        searchText: '',
    }

    render() {
        const { items, title, searchButtonText } = this.props;

        return (
            <div className="keyword-app">
                <h3>{title}</h3>
                <div className="keyword-search">
                    <Textbox
                        id="keyword-search-input"
                        value={this.state.inputText}
                        onInput={(e) => this.onInputChange(e.currentTarget.value)}
                        onKeyPress={this.onKeyPress}
                        isControlled={true}
                    />
                    <button
                        className="global-search-bar-button button-primary search-box-text"
                        onClick={this.onSearch}>
                        {searchButtonText}
                    </button>
                </div>
                <div className="alphabet-list">
                    {this.renderAlphabetList()}
                </div>
                <ul className="results">
                    {this.renderResults(items)}
                </ul>
            </div>
        )
    }

    onSearch = () => {
        this.setState(prevState => ({ searchText: prevState.inputText, currentLetter: '' }));
    }

    onInputChange = (value: string) => {
        this.setState({inputText: value});
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.onSearch();
        }
    }

    renderAlphabetList = () => {
        let alphabet = [];
        const { currentLetter } = this.state;
        for (let item in Alphabet) {
            alphabet.push(item);
        }

        return alphabet.map(x => this.renderAlphabetCard(x));
    }

    renderAlphabetCard = (letter: string) => {
        let selected = this.state.currentLetter === letter;
        let disabled = !this.props.items.some(x => x.title.charAt(0).toLowerCase() === letter.toLowerCase());
        return (
            <input
                type="button"
                value={letter}
                className={"alphabet-list-item " + (selected ? "selected" : "")}
                key={letter}
                onClick={() => this.onLetterClick(letter)}
                disabled={disabled}>
            </input>
        );
    }

    onLetterClick = (letter: string) => {
        let currentLetter = this.state.currentLetter === letter ? '' : letter;
        this.setState({ currentLetter, searchText: '', inputText: '' });
    }

    renderResults = (items: IKeywordElement[]) => {
        const { currentLetter, searchText } = this.state;

        if (searchText) {
            items = items.filter(x => x.title.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1 || this.containsKeyword(x));
        }
        else if (currentLetter) {
            items = items.filter(x => x.title.charAt(0).toLowerCase() === currentLetter.toLowerCase());
        }

        return items.map((item, i) => this.renderItem(item, i))
    }

    renderItem = (item: IKeywordElement, index: number) => {
        return (
            <li className="keyword-result" key={item.title + index}>
                <a href={item.pageLink}>{item.title}</a>
            </li>
        );
    }

    containsKeyword = (item: IKeywordElement) => {
        const { searchText } = this.state;

        if (!item.keywords) return false;

        for (let i = 0; i < item.keywords.length; i++) {
            if (!item.keywords[i] || item.keywords[i].trim().length === 0) continue;

            if (searchText.toLowerCase().trim().indexOf(item.keywords[i].toLowerCase()) !== -1) {
                return true;
            }
        }

        return false;
    }    
}

